module.exports = __webpack_public_path__ + "static/media/view.c4701080.svg";